import { z } from "zod";

export const inviteUserProfileFormSchema = z.object({
    firstName: z.string().min(1, "First name is required"),
    lastName: z.string().min(1, "Last name is required"),
});

export type InviteUserProfileFlowFormSchema = z.infer<
    typeof inviteUserProfileFormSchema
>;

export function getMultiSelectTriggerValue<T>(
    selectedValues: T[],
    totalCount: number,
    getLabel: (value: T) => string,
): string {
    if (!selectedValues.length) {
        return "Select";
    }

    if (selectedValues.length === totalCount) {
        return "All";
    }

    const labels = selectedValues.map(getLabel);

    if (labels.length <= 2) {
        return labels.join(", ");
    }

    return `${labels.slice(0, 2).join(", ")}, and ${labels.length - 2} more`;
}
